import axios from 'axios';
//Production 
const baseDomain = 'https://apps.lavote.gov';
const baseURL = `${baseDomain}/statements-api`;
//Dev
//const baseDomain = 'https://azjeditest01:44305';
//const baseURL = `${baseDomain}/statements-api`;
//const baseDomain = 'https://localhost:44306';
//const baseURL = `${baseDomain}/statements-api`;

export default axios.create({
    baseURL
});   